/**
 * Auth Context
 * Provides authentication and admin status to the app
 */

/// <reference path="../vite-env.d.ts" />

import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi, AuthStatus } from '../api/auth.js';

interface AuthContextValue {
  loading: boolean;
  authenticated: boolean;
  isAdmin: boolean;
  userId?: string;
}

const AuthContext = createContext<AuthContextValue>({
  loading: true,
  authenticated: false,
  isAdmin: false,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [auth, setAuth] = useState<AuthContextValue>({
    loading: true,
    authenticated: false,
    isAdmin: false,
  });

  useEffect(() => {
    authApi.me()
      .then((status: AuthStatus) => {
        setAuth({
          loading: false,
          authenticated: status.authenticated,
          isAdmin: import.meta.env.DEV ? true : status.is_admin,
          userId: status.user_id,
        });
      })
      .catch(() => {
        setAuth({
          loading: false,
          authenticated: false,
          isAdmin: import.meta.env.DEV,
        });
      });
  }, []);

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};
